<div class="container">
  <mic-breadcrumb id="casing-search-result-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/search-casings"
      label="{{ this.translationService.translate('searchCasingsText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ this.translationService.translate('casingListText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="flex justify-between items-center mb-3">
    <h2 class="m-0 mt-3" id="casing-list-heading">{{ this.translationService.translate('casingListText') }}</h2>
    <div class="flex gap-3">
      <button id="export-button" type="button" mat-flat-button color="primary" (click)="openExportModal()">
        <mat-icon>download</mat-icon>
        <span>{{ translationService.translate('exportText') }}</span>
      </button>

      <span
        [matTooltip]="!canDeleteSelection() ? translationService.translate('notEligibleToDeleteText') : ''"
        [matTooltipDisabled]="canDeleteSelection()"
      >
        <button id="bulk-delete-button" type="button" mat-flat-button color="warn" (click)="onDelete()" [disabled]="!canDeleteSelection()">
          <mat-icon>delete</mat-icon>
          <span>{{ translationService.translate('deleteText') }}</span>
        </button>
      </span>

      <button id="back-button" type="button" mat-flat-button (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>{{ translationService.translate('backButtonText') }}</span>
      </button>

      <!-- ***this functionality is yet to be built hence hiding transfer, remove the @if once the functionality is implemented*** -->
      <!--      Forced disabled as it going to be used for bluk-->
      @if(isDeleteWorkOrderEnabled && false){
      <button id="delete-button" mat-flat-button color="warn">
        <mat-icon>delete</mat-icon>
        <span>{{ translationService.translate('deleteText') }}</span>
      </button>
      } @if (showTransferButton && isRSCasingTransferEnabled) {
      <span [matTooltip]="getTransferTooltipMessage()" [matTooltipDisabled]="canTransferSelection()">
        <button id="transfer-button" type="button" mat-flat-button color="primary" (click)="onTransfer()" [disabled]="!hasSelection()">
          <mat-icon>transfer_within_a_station</mat-icon>{{ this.translationService.translate('transferText') }}
        </button>
      </span>
      }
    </div>
  </div>
  @if ((filterTags$ | async); as filterTags) { @if (filterTags.length > 0) {
  <mat-chip-set id="casing-search-filter-tags" class="mb-3">
    @for (tag of filterTags; track tag.id) {
    <mat-chip disableRipple color="secondary" (removed)="removeFilter(tag)">
      {{ tag.label }}: {{ tag.value }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
    }
  </mat-chip-set>
  } }
  <div id="casing-search-result-table" class="cam-table">
    <div class="table-wrapper">
      <mic-table
        appCopyOnSelect
        #paginatedTable
        class="table-stripped"
        [config]="tableConfig"
        [fetcher]="fetcher"
        [uniqueKey]="'workOrderLinePk'"
      >
        <!-- Custom cell templates for clickable links -->
        <ng-container *micCellTemplate="let item; name: 'casingIdCell'">
          <div class="flex items-center">
            <mic-link [label]="item.casingId" (click)="onCasingIdClick(item)"></mic-link>
            @if (loadingCasingId === item.casingId) {
            <mat-spinner diameter="16" style="margin-left: 8px"></mat-spinner>
            }
          </div>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'workOrderNumCell'">
          <div class="flex items-center">
            <mic-link [label]="item.workOrderNum" (click)="onWorkOrderNumClick(item)"></mic-link>
            @if (loadingWorkOrderNum === item.workOrderNum) {
            <mat-spinner diameter="16" style="margin-left: 8px"></mat-spinner>
            }
          </div>
          <ng-template #noWorkOrder>-</ng-template>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'casingStatusCell'">
          <mic-status [matTooltip]="getCasingStatusTooltip(item.casingStatus)" [class]="getStatusClass(item.casingStatus)">
            {{ getStatusLabel(item.casingStatus) }}
          </mic-status>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'creationDateCell'">
          {{ formatCreationDate(item.creationDate) }}
        </ng-container>
        <ng-container *micTableRowMenu="let item">
          @if (isDeleteWorkOrderEnabled) {
          <span
            [matTooltip]="!isDeletableCasingStatus(item.casingStatus) ? translationService.translate('notEligibleToDeleteText') : ''"
            [matTooltipDisabled]="isDeletableCasingStatus(item.casingStatus)"
            matTooltipPosition="above"
          >
            <button
              id="delete-casing"
              type="button"
              (click)="onDeleteClick(item)"
              [disabled]="!isDeletableCasingStatus(item.casingStatus)"
              mat-menu-item
            >
              <mat-icon class="delete-icon-only">delete</mat-icon> {{ translationService.translate('deleteWOLineText') }}
            </button>
          </span>
          }
        </ng-container>
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="No data found"></mic-empty-state>
        </ng-container>
        <ng-container *micTableColumnSelector>
          <button mat-flat-button [matMenuTriggerFor]="colMenu" (click)="$event.stopPropagation()">
            <mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}
          </button>
          <mat-menu #colMenu="matMenu">
            <div
              class="column-menu-content column-menu-list"
              cdkDropList
              [cdkDropListData]="columnOrder"
              (cdkDropListDropped)="onColumnDrop($event)"
            >
              @for (key of columnOrder; track key) {
              <div class="column-menu-item" cdkDrag>
                <mat-icon class="column-drag-handle" cdkDragHandle aria-hidden="true">drag_indicator</mat-icon>
                <mat-checkbox [checked]="columnVisibility[key]" (click)="$event.stopPropagation()" (change)="toggleColumn(key)">
                  {{ columnNames[key] || key }}
                </mat-checkbox>
              </div>
              }
            </div>
          </mat-menu>
          @if (paginatedTable.selectedItems.length > 0) {
          <span class="selected-count-text"> {{ paginatedTable.selectedItems.length }} selected </span>
          }
          <span class="table-counts">{{ getDisplayedTotalCountLabel() }}</span>
        </ng-container>
      </mic-table>
    </div>
  </div>
</div>

<mic-modal #transferValidationModal></mic-modal>
<ng-template #transferValidationContent>
  @if (transferValidationMessages.length > 0) { @for (message of transferValidationMessages; track message) {
  <div>{{ message }}</div>
  } } @else { {{ translationService.translate('transferValidationFallbackText') }} }
</ng-template>

<mic-modal #transferConfirmationModal></mic-modal>
<ng-template #transferConfirmationContent>
  <div style="font-size: 16px; margin-bottom: 18px">{{ translationService.translate('transferConfirmationPromptText') }}</div>
  <div style="border-top: 1px solid #d8d8d8; margin: 18px 0 22px"></div>
  <div class="transfer-confirmation-actions">
    <button
      id="transfer-cancel-button"
      type="button"
      mat-flat-button
      class="transfer-confirmation-btn"
      (click)="closeTransferConfirmationModal()"
    >
      {{ translationService.translate('cancelText') }}
    </button>
    <button type="button" mat-flat-button color="primary" class="transfer-confirmation-btn" (click)="onTransferToNewWorkOrder()">
      {{ translationService.translate('transferToNewWOButtonText') }}
    </button>
    <button type="button" mat-flat-button color="primary" class="transfer-confirmation-btn" (click)="onTransferToExistingWorkOrder()">
      {{ translationService.translate('addToExistingWOButtonText') }}
    </button>
  </div>
</ng-template>
